import { LoadingStatus } from '../../types/profile';
import { PropsWithChildren } from 'react';
import { SkeletonLoader } from './SkeletonPlaceHolderStyle';

export interface SkeletonPlaceholderProps extends PropsWithChildren {
  loadingStatus?: LoadingStatus;
}

export default function SkeletonPlaceholder({ children, loadingStatus }: SkeletonPlaceholderProps) {
  return (
    <>
      {loadingStatus === LoadingStatus.SUCCEEDED && children}
      {loadingStatus === LoadingStatus.FAILED && null}
      {!loadingStatus ||
        loadingStatus === LoadingStatus.UNSET ||
        (loadingStatus === LoadingStatus.IN_PROGRESS && <SkeletonLoader animation={`wave`} />)}
    </>
  );
}
